import React from 'react'

export default () => <img style={{maxHeight: '35px'}} src="/logo_isdin.png" alt="ISDIN" />
